// extracted by mini-css-extract-plugin
export var bold = "_yz-0";